module.exports = __webpack_public_path__ + "static/media/tracefinancialblue 700x250 (1).6bd84975.png";